import React from 'react';
import { Box, Typography } from '@mui/material';

function GlobalLoader({ message = 'Cargando...', minHeight = '45vh', fullscreen = false }) {
    return (
        <Box
            className={fullscreen ? 'react-global-loader is-fullscreen' : 'react-global-loader'}
            sx={{
                minHeight: fullscreen
                    ? { xs: '100dvh', sm: '100vh' }
                    : {
                        xs: `max(${minHeight}, 70dvh)`,
                        sm: `max(${minHeight}, 70dvh)`,
                    },
                paddingTop: { xs: '44px', sm: 0 },
            }}
        >
            <Box className="react-global-loader-stack" aria-hidden="true">
                <Box className="react-global-loader-ring" />
                <Box className="react-global-loader-ring react-global-loader-ring--inner" />
            </Box>
            <Typography variant="subtitle1" className="react-global-loader-label" aria-live="polite">
                {message}
            </Typography>
        </Box>
    );
}

export default GlobalLoader;